import { Injectable } from '@angular/core';
import { DwContextDefinition, DwCustomContextBase, DwCustomContextDefinition, DwQuery, DwQueryHelper } from '@devwareapps/devware-cap';
import { AppMetaDataItemNames } from '../../../meta-data/app-meta-data.service';
import { UserTeamLookup } from '../models/user-team-lookup.model';

@DwCustomContextDefinition({
    keyName: 'EmployeeMonthlyNumbers',
    display: 'Employee Monthly Numbers - Custom',
    item: 'UserYearNumbers',
    parentItem :'UserTeamLookup',
    isGlobal: false,
})
@Injectable()
export class EmployeeMonthlyNumbersContextService extends DwCustomContextBase {

    setupContextDefinition(contextDef: DwContextDefinition) {
        
        contextDef.getCustomContextKey = (resolvedContext) => this.getCustomContextKey(resolvedContext);

        // Add custom functions to the context definition
        contextDef.buildQueryFunction = (resolvedContext) => this.buildQuery(resolvedContext);
    }

    buildQuery(resolvedContext: any): DwQuery {
        // Get the form data
        const userTeamLookup: UserTeamLookup = resolvedContext?.data;

        // If we're missing either field, don't run a query
        if (!userTeamLookup?.Ethos_UserId || !userTeamLookup?.FiscalYear) {
            return null;
        }

        // query user year numbers
        const query = new DwQuery('UserYearNumbers');
        const qh = new DwQueryHelper();

        query.AddFilterAnd(qh.filters.Equal("Ethos_UserId", userTeamLookup.Ethos_UserId));
        query.AddFilterAnd(qh.filters.Equal("FiscalYear", userTeamLookup.FiscalYear));

        return query;
    }

    getCustomContextKey(resolvedContext: any) {
        const userTeamLookup: UserTeamLookup = resolvedContext["data"];

          // If we're missing either field, don't run a query
          if (!userTeamLookup?.Ethos_UserId || !userTeamLookup?.FiscalYear) {
            return 'none';
        }

        return `${userTeamLookup.Ethos_UserId}_${userTeamLookup.FiscalYear}`;
    }

}